export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDDhsgTAmdBV1NGgSn2D10RsCYPJ89iI64",
  authDomain: "waste-map-b65be.firebaseapp.com",
  projectId: "waste-map-b65be",
  storageBucket: "waste-map-b65be.firebasestorage.app",
  messagingSenderId: "356122826251",
  appId: "1:356122826251:web:06bbe59bfe0a05d4fbd90e",
  measurementId: "G-C2NE1FTPRZ"
};
